// extracted by mini-css-extract-plugin
export default {"section":"styles_section__GxJTW","inner":"styles_inner__hhCHk","body":"styles_body__3UMPI","item":"styles_item__q36Ef","title":"styles_title__TXXXR","aside":"styles_aside__X5R66"};